import { render } from "./ContentRecipeComposer.vue?vue&type=template&id=3365a6a6&scoped=true"
import script from "./ContentRecipeComposer.vue?vue&type=script&lang=js"
export * from "./ContentRecipeComposer.vue?vue&type=script&lang=js"

import "./ContentRecipeComposer.vue?vue&type=style&index=0&id=3365a6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3365a6a6"]])

export default __exports__